import { render } from "./FacesheetComments.vue?vue&type=template&id=d7f8133a"
import script from "./FacesheetComments.ts?vue&type=script&lang=js&external"
export * from "./FacesheetComments.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__